import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/disk/hezi.webp'


const _withScopeId = n => (_pushScopeId("data-v-591d1ed5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "about-hezi" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "hezi"
  })
], -1))
const _hoisted_3 = { class: "about-section" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "关于本机", -1))
const _hoisted_5 = { class: "about-list" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "设备名称", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M4.16667 4.16667H12.5V2.5H3.41667C2.9104 2.5 2.5 2.91041 2.5 3.41667V16.5833C2.5 17.0896 2.91041 17.5 3.41667 17.5H16.5833C17.0896 17.5 17.5 17.0896 17.5 16.5833V8.33333H15.8333V15.8333H4.16667V4.16667Z",
    fill: "#6A707C"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M17.2559 4.75592L9.33926 12.6726L8.16074 11.4941L16.0774 3.57741L17.2559 4.75592Z",
    fill: "#6A707C"
  })
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "设备状态", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "设备IP", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "设备ID", -1))
const _hoisted_12 = { class: "about-device-id" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M16.6667 6.75C16.6667 6.24375 16.2563 5.83333 15.75 5.83333H6.75C6.24375 5.83333 5.83333 6.24373 5.83333 6.75V16.5833C5.83333 17.0896 6.24373 17.5 6.75 17.5H15.75C16.2563 17.5 16.6667 17.0896 16.6667 16.5833V6.75ZM15 7.5V15.8333H7.5V7.5H15Z",
    fill: "#6A707C"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M11.6667 4.16667V6.66667H13.3333V3.41667C13.3333 2.9104 12.9229 2.5 12.4167 2.5H3.41667C2.91041 2.5 2.5 2.9104 2.5 3.41667V14.0833C2.5 14.5896 2.9104 15 3.41667 15H6.38889V13.3333H4.16667V4.16667H11.6667Z",
    fill: "#6A707C"
  })
], -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Samba", -1))
const _hoisted_16 = { class: "about-device-smb" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Windows：", -1))
const _hoisted_18 = { class: "about-device-id" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M16.6667 6.75C16.6667 6.24375 16.2563 5.83333 15.75 5.83333H6.75C6.24375 5.83333 5.83333 6.24373 5.83333 6.75V16.5833C5.83333 17.0896 6.24373 17.5 6.75 17.5H15.75C16.2563 17.5 16.6667 17.0896 16.6667 16.5833V6.75ZM15 7.5V15.8333H7.5V7.5H15Z",
    fill: "#6A707C"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M11.6667 4.16667V6.66667H13.3333V3.41667C13.3333 2.9104 12.9229 2.5 12.4167 2.5H3.41667C2.91041 2.5 2.5 2.9104 2.5 3.41667V14.0833C2.5 14.5896 2.9104 15 3.41667 15H6.38889V13.3333H4.16667V4.16667H11.6667Z",
    fill: "#6A707C"
  })
], -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "about-device-smb" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Mac OS：", -1))
const _hoisted_23 = { class: "about-device-id" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M16.6667 6.75C16.6667 6.24375 16.2563 5.83333 15.75 5.83333H6.75C6.24375 5.83333 5.83333 6.24373 5.83333 6.75V16.5833C5.83333 17.0896 6.24373 17.5 6.75 17.5H15.75C16.2563 17.5 16.6667 17.0896 16.6667 16.5833V6.75ZM15 7.5V15.8333H7.5V7.5H15Z",
    fill: "#6A707C"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M11.6667 4.16667V6.66667H13.3333V3.41667C13.3333 2.9104 12.9229 2.5 12.4167 2.5H3.41667C2.91041 2.5 2.5 2.9104 2.5 3.41667V14.0833C2.5 14.5896 2.9104 15 3.41667 15H6.38889V13.3333H4.16667V4.16667H11.6667Z",
    fill: "#6A707C"
  })
], -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "about-section" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "硬件信息", -1))
const _hoisted_28 = { class: "about-list" }
const _hoisted_29 = ["disabled"]

import { computed, onMounted, ref, watch } from 'vue'
import copy from 'clipboard-copy'
import { useRouter } from 'vue-router'
import { store } from '@remote/store'
import Page from '@remote/components/layout/SubPage.vue'
import Modal from '@remote/components/modal'
import { getDeviceList as getDeviceListApi, updateDeviceName } from '@remote/api/adapter/api-http/index'
import { rebootDevice, shutdownDevice } from '@remote/api/adapter/xos-mqtt'
import { IDeviceInfo } from '@remote/type/device'
import { DEVICE_STATUS, DEVICE_STATUS_CLASS } from '@remote/constant'
import { toast } from '@remote/utils/dialog'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const curDeviceRunner = computed(() => store.state.curDeviceRunner)
const deviceDetail = ref<Pick<IDeviceInfo, 'hardwareinfo' | 'cookie'>>({ hardwareinfo: [], cookie: '' })
const disabled = computed(() => store.state.curDeviceRunner.status !== 1)

const getDeviceList = () => {
  getDeviceListApi()
    .then(res => {
      const [err, result] = res
      if (!err && result?.ret === 0) {
        const target = result.data.list?.find(item => item.device_id === curDeviceRunner.value.params?.target)
        if (target) deviceDetail.value = target
      }
    })
}

onMounted(() => {
  getDeviceList()
})

watch(disabled, () => {
  getDeviceList()
})

const handleRename = () => {
  Modal.rename({
    title: '设备重命名',
    defaultValue: curDeviceRunner.value.name,
    maskClosable: true,
    placeholder: '请填写设备名称',
    callback: (newName: string) => {
      if (disabled.value) {
        toast({type: 'warn', message: '设备已离线暂不支持修改'})
        return Promise.resolve(false)
      }

      return updateDeviceName({
        cookie: '',
        device_id: curDeviceRunner.value.params?.target,
      }, newName).then(res => {
        const [err, result] = res
        if (!err && result.ret === 0) {
          toast({type: 'success', message: '修改成功'})
          store.commit('update', {
            curDeviceRunner: Object.assign({}, curDeviceRunner.value, { name: newName }),
          })
          return Promise.resolve(true)
        } else {
          toast({type: 'error', message: err?.error_description || result.msg})
          return Promise.resolve(false)
        }
      }).catch(err => {
        toast({type: 'error', message: err})
        return Promise.resolve(false)
      })
    },
    isSelect: true,
    // maxlength: 20,
  })
}

const handleRebootDevice = () => {
  const callback = () => {
    toast({type: 'loading', message: '设备重启中，请耐心等待...'})
    rebootDevice(curDeviceRunner.value.params?.target, deviceDetail.value.cookie)
      .then(res => {
        if (res.ret === 0) {
          // store.commit('toast', '设备重启成功')
          store.commit('update', {
            curDeviceRunner: Object.assign({}, curDeviceRunner.value, { status: 3 }),
          })
        } else {
          toast({type: 'error', message: res.msg || '设备重启失败'})
        }
      }).catch(err => {
        toast({type: 'error', message: err})
      })
  }
  Modal.show({
    title: '确定要重启盒子设备吗？',
    actions: [{
      id: 'reboot',
      text: '重启',
      callback,
    }],
  })
}

const handleShutdownDevice = () => {
  const callback = () => {
    toast({type: 'loading', message: '设备关机中，请耐心等待...'})
    shutdownDevice(curDeviceRunner.value.params?.target, deviceDetail.value.cookie)
      .then(res => {
        if (res.ret === 0) {
          // store.commit('toast', '设备关机成功')
          store.commit('update', {
            curDeviceRunner: Object.assign({}, curDeviceRunner.value, { status: -1 }),
          })
        } else {
          toast({type: 'error', message: res.msg || '设备关机失败'})
        }
      }).catch(err => {
        toast({type: 'error', message: err})
      })
  }
  Modal.show({
    title: '确定要关机盒子设备吗？',
    actions: [{
      id: 'reboot',
      text: '关机',
      callback,
    }],
  })
}

const handleOnCopy = (text: string) => {
  copy(text)
  toast({type: 'success', message: '复制成功'})
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Page, {
    title: "设备详情",
    bg: "#fff"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("section", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", null, [
              _hoisted_6,
              _createElementVNode("span", null, _toDisplayString(_unref(curDeviceRunner).name), 1),
              _createElementVNode("a", {
                class: "copy-btn",
                onClick: handleRename
              }, _hoisted_8)
            ]),
            _createElementVNode("li", null, [
              _hoisted_9,
              _createElementVNode("span", {
                class: _normalizeClass(["about-device-state", [_unref(DEVICE_STATUS_CLASS)[_unref(curDeviceRunner).status] || 'offline']])
              }, _toDisplayString(_unref(DEVICE_STATUS)[_unref(curDeviceRunner).status] || '离线'), 3)
            ]),
            _createElementVNode("li", null, [
              _hoisted_10,
              _createElementVNode("span", null, _toDisplayString(_unref(curDeviceRunner)?.params?.lan_ip), 1)
            ]),
            _createElementVNode("li", null, [
              _hoisted_11,
              _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(curDeviceRunner).target), 1),
              _createElementVNode("a", {
                class: "copy-btn",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (handleOnCopy(_unref(curDeviceRunner).target)))
              }, _hoisted_14)
            ]),
            _createElementVNode("li", null, [
              _hoisted_15,
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("span", _hoisted_18, "\\\\" + _toDisplayString(_unref(curDeviceRunner)?.params?.lan_ip), 1),
                  _createElementVNode("a", {
                    class: "copy-btn",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (handleOnCopy(`\\\\${_unref(curDeviceRunner)?.params?.lan_ip}`)))
                  }, _hoisted_20)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("span", _hoisted_23, "smb://" + _toDisplayString(_unref(curDeviceRunner)?.params?.lan_ip), 1),
                  _createElementVNode("a", {
                    class: "copy-btn",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (handleOnCopy(`smb://${_unref(curDeviceRunner)?.params?.lan_ip}`)))
                  }, _hoisted_25)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("section", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("ul", _hoisted_28, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deviceDetail.value.hardwareinfo, (item, i) => {
              return (_openBlock(), _createElementBlock("li", { key: i }, [
                _createElementVNode("label", null, _toDisplayString(item.label), 1),
                _createElementVNode("span", null, _toDisplayString(item.value), 1)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", {
          class: "about-btns",
          disabled: _unref(disabled)
        }, [
          _createElementVNode("a", { onClick: handleRebootDevice }, "设备重启"),
          _createElementVNode("a", { onClick: handleShutdownDevice }, "设备关机")
        ], 8, _hoisted_29)
      ])
    ]),
    _: 1
  }))
}
}

})